import { createSlice } from '@reduxjs/toolkit';

import { State, STATE } from "../types/state";

import setSettings from './setSettings';
import updateSettings from './updateSettings';
import setSettingsStatusLoading from './setSettingsStatusLoading';
import setUpdateSettingsStatusLoading from './setUpdateSettingsStatusLoading';

const initialState: State = {
  settings: {},
  autosCoordinates: {}
};

const slice = createSlice({
  name: STATE,
  initialState,
  reducers: {
    setSettings,
    updateSettings,
    setSettingsStatusLoading,
    setUpdateSettingsStatusLoading
  }
});

export default slice;
